import { render, staticRenderFns } from "./diapositiva-9.vue?vue&type=template&id=0b9b8c2e&scoped=true&"
import script from "./diapositiva-9.vue?vue&type=script&lang=js&"
export * from "./diapositiva-9.vue?vue&type=script&lang=js&"
import style0 from "./diapositiva-9.vue?vue&type=style&index=0&id=0b9b8c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9b8c2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Ripple } from 'vuetify/lib/directives'
installDirectives(component, {Ripple})
